export function formatDate(iso: string): string {
  const date = new Date(iso);

  if (Number.isNaN(date.getTime()) || date.getFullYear() < 1970) {
    return "Unknown";
  }

  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
